import React from 'react';
import { TextField, useTranslate } from 'react-admin';

interface TimeFieldProps {
	record?: any;
	source: string;
	label: string;
}

const TimeField: React.FC<TimeFieldProps> = ({ record, source, label }) => {
	const translator = useTranslate();

	const formatTime = (value) => {
		if (!value) {
			return '';
		}
		const date = new Date(value);
		const hours = date.getHours().toString().padStart(2, '0');
		const minutes = date.getMinutes().toString().padStart(2, '0');
		return `${hours}:${minutes}`;
	};

	const formattedTime = formatTime(record && record[source]);

	return (
		<TextField
			source={source}
			label={translator(label)}
			record={record}
			defaultValue={formattedTime}
		/>
	);
};

export default TimeField;
